module.exports = __webpack_public_path__ + "img/manage02.9d214870.png";